
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'services/authentication.service';

@Component({
  selector: 'app-manageotpnotification',
  templateUrl: './manageotpnotification.component.html',
  styleUrls: ['./manageotpnotification.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
      transition('expanded <=> collapsed', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ManageOtpNotificationComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
  filterOpen = false;
  data: any[] = [];
  form: FormGroup
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    'recipient',
    'OTP',
    'TimeStamp'
  ];


  constructor(
    private authService: AuthenticationService,
    private FormBuilder: FormBuilder,
    private toastr: ToastrService

  ) { }

  ngOnInit(): void {
    this.form = this.FormBuilder.group({
      recipient: [null],
      otp: [null]

    })
    this.getData()
  }

  getData() {
    this.authService.GetOtpNotificationMessage().subscribe((result) => {
      if (result && result.value && result.value.length > 0) {
        this.data = result.value;
        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      } else {
        this.data = [];
        this.dataSource = new MatTableDataSource([]);
      }
    });
  }
  search() {
    const value = this.form.controls.recipient.value;
    if (!value) {
      this.dataSource.filter = '';
      return;
    }
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      if (!data.recipient) {
        return false;
      }
      return data.recipient
        .toString()
        .toLowerCase()
        .includes(filter);
    };

    this.dataSource.filter = value.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  reset() {
    this.form.reset();

    this.dataSource.filter = '';

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  refresh() {
    this.form.reset();
    this.getData();
  }

}
